import {
  isElement,
  removeNodes,
  setNodes,
  getPluginOptions,
} from '@udecode/plate-common';
import { getTableColumnCount, ELEMENT_TABLE } from '@udecode/plate-table';

import { KEY_DOCUMENT_SETTINGS } from '../document-settings/createDocumentSettingsPlugin';

/**
 * Normalize table:
 *  - remove children that aren't table rows.
 *  - adds default col sizes if it does not exist.
 *  - move table cell attributes colspan and rowspan to the element.
 */
export const withNormalizeTable2 = (editor) => {
  const { normalizeNode } = editor;

  editor.normalizeNode = ([node, path]) => {
    if (isElement(node)) {
      // Check for non TR elements within a table's children. Remove if exists.
      if (node.type === 'table') {
        const { children: rows, colSizes } = node;

        const found = rows.findIndex(row => row.type !== 'tr');
        if (found >= 0) {
          removeNodes(editor, { at: [...path, found] });
          return;
        };

        if (!colSizes) {
          const maxColLength = getTableColumnCount(node);
          const { minColumnWidth = 48 } = getPluginOptions(editor, ELEMENT_TABLE);
          const { innerWidth = minColumnWidth } = getPluginOptions(editor, KEY_DOCUMENT_SETTINGS);
          const width = Math.floor(innerWidth / maxColLength);
          const newColSizes = Array(maxColLength).fill(width);
          setNodes(editor, { colSizes: newColSizes }, { at: path });
          return;
        }
      }

      if (node.type === 'td') {
        const { attributes, colSpan, rowSpan } = node;
        const { colspan, rowspan } = attributes || {};

        if (colspan && !colSpan) {
          setNodes(editor, { colSpan: parseInt(colspan, 10) }, { at: path });
          return;
        }
        if (rowspan && !rowSpan) {
          setNodes(editor, { rowSpan: parseInt(rowspan, 10) }, { at: path });
          return;
        }
      }
    }
    return normalizeNode([node, path]);
  };

  return editor;
};
